import { type DatabaseChangeType } from '@databases/types/redux';

import { getValueId } from '../../../../utils.ts';
import { type YJSChangeHandler } from '../../types.ts';

export const incrementValueCommentThreadCommentCount: YJSChangeHandler<
  DatabaseChangeType.INCREMENT_VALUE_COMMENT_THREAD_COMMENT_COUNT
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    db.incrementCommentThreadCommentCount(
      getValueId(change.entryId, change.fieldId),
      change.threadId
    );
  });
};
